<c-toaster
  [placement]="position"
  class="p-3"
  position="fixed"
  *ngIf="data.visible">
  <c-toast (visibleChange)="onVisibleChange($event)" [visible]="data.visible">
    <c-toast-header>
      <svg size="lg" class="text-primary m-2" [cIcon]="cilAudio"></svg>
      {{ data.text.title }}
    </c-toast-header>
    <c-toast-body>
      <p>{{ data.text.message }}</p>
      <c-progress thin *ngIf="data.percentage > 0">
        <c-progress-bar [value]="data.percentage"></c-progress-bar>
      </c-progress>
    </c-toast-body>
  </c-toast>
</c-toaster>
